import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'app-add-course',
  templateUrl: './add-course.component.html',
  styleUrls: ['./add-course.component.scss']
})
export class AddCourseComponent implements OnInit {
  courseForm!: FormGroup;
  fileUpload!: File;
  loader: boolean = false;
  plans: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddCourseComponent>,
    private adminservice: AdminService
  ) { }

  ngOnInit() {
    this.fileUpload = this.data.file;
    this.formBuilder();
    if (this.data.course?.id > 0 || this.data.course?.curso_id > 0) {
      const data = {
        courseId: this.data.course.id ? this.data.course.id : this.data.course.curso_id,
        title: this.data.course.titulo,
        description: this.data.course.descripcion,
        plans: this.data.course.plan_id
      }
      this.courseForm.patchValue(data);
    }
    this.getPlans()
  }

  formBuilder(){
    this.courseForm = new FormGroup({
      courseId: new FormControl(0, Validators.required),
      title: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required),
      plans: new FormControl(null, Validators.required),
    });
  }

  saveDataCourse(){
    if (!this.courseForm.valid) {
      return
    }

    const request = {
      curso_id: this.courseForm.value.courseId,
      titulo: this.courseForm.value.title,
      descripcion: this.courseForm.value.description,
      plan_id: this.courseForm.value.plans
    }
    this.loader = true;
    this.adminservice.saveCourse(request, this.fileUpload).subscribe(
      (response)=>{
        this.loader = false;
        if (response.rtn && response.result > 0) {
          request.curso_id = response.result;
          this.dialogRef.close(request)
        }
      }
    );
  }

  getPlans():void {
    this.adminservice.getPlans().subscribe(response => response.rtn && response.result ? this.plans = response.result : []);
  }
  
}
